import firebase from 'firebase';
import 'firebase/storage';
import 'firebase/functions';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyBbXM5qCWplc0CHJQXSaHxu-9lZR3lDL5k',
  authDomain: 'duangtoday-billing-e874b.firebaseapp.com',
  databaseURL: 'https://duangtoday-billing-e874b.firebaseio.com',
  projectId: 'duangtoday-billing-e874b',
  storageBucket: 'duangtoday-billing-e874b.appspot.com',
  messagingSenderId: '828607568922',
  appId: '1:828607568922:web:425e6174f183db920745a3',
  measurementId: 'G-W3TKGC5Y3X',
};

firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();
const functions = firebase.app().functions('asia-east2');
const db = firebase.firestore();

export { storage, functions, db, firebase as default };
